/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}

interface CardListHeadingStyle {
    linkStyle?: LinkPresentationProps;
}

export const cardListHeadingStyle: CardListHeadingStyle = {
    linkStyle: {
        css: css`
            margin-left: auto;
            margin-top: 5px;
            font-size: ${TYPOGRAPHY.size.small};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: ${TYPOGRAPHY.size.smaller};
                    `,
                    css`
                        font-size: ${TYPOGRAPHY.size.smaller};
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};

const styles = cardListHeadingStyle;

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return (
        <GridItem width={12}>
            <GridContainer
                offsetCss={css`
                    border-bottom: 1px solid ${getColor("common.border")};
                    padding-top: 40px;
                    &&& {
                        width: 100%;
                    }
                `}
            >
                <GridItem width={8}>
                    <Typography className="card-list-heading" variant="h2">
                        {heading}
                    </Typography>
                </GridItem>
                {viewAllUrl && (
                    <GridItem width={4}>
                        <Link
                            {...styles.linkStyle}
                            href={viewAllUrl}
                            icon={{ iconProps: { src: ChevronRight } }}
                            className="view-all-link"
                            data-test-selector="cardListHeadingViewAllLink"
                        >
                            {translate("View All")}
                            <VisuallyHidden>
                                {translate("View All")} {heading}
                            </VisuallyHidden>
                        </Link>
                    </GridItem>
                )}
            </GridContainer>
        </GridItem>
    );
};

export default CardListHeading;
